export const DividerStyle = {
    background: 'rgba(255, 255, 255, 0.12)', 
    width: '100%'
}